import React from 'react'

export const SelectorContext = React.createContext()
export const SelectorProvider = SelectorContext.Provider
export const SelectorConsumer = SelectorContext.Consumer

export const ThemeCtx = React.createContext({ theme : 'default' });
